module.exports = __webpack_public_path__ + "media/images/arrow_right-dc78710471858ce7c18cc65afe7a8672.svg";